export const WEEK = 'week';
export const MONTH = 'month';
export const YEAR = 'year';
